var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.58 12.006 7.832 4.265a1.23 1.23 0 0 1-.382-.935q.014-.54.409-.935T8.795 2t.935.395l8.089 8.11q.316.316.474.711.158.396.158.79 0 .396-.158.79-.158.395-.474.711l-8.115 8.11q-.395.395-.922.383a1.31 1.31 0 0 1-.922-.409 1.28 1.28 0 0 1-.395-.934q0-.54.395-.935z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.4760d59532879482f861e026c424b4cf.svg";
export { ForwardRef as ReactComponent };